/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Demo_H_GeneralInputs */

const en_funnel_ob_demo_h_general = /** @type {(inputs: Funnel_Ob_Demo_H_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hear it in a voice that sounds like a real person.`)
};

const es_funnel_ob_demo_h_general = /** @type {(inputs: Funnel_Ob_Demo_H_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escúchalo con una voz que suena como una persona real.`)
};

/**
* | output |
* | --- |
* | "Hear it in a voice that sounds like a real person." |
*
* @param {Funnel_Ob_Demo_H_GeneralInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_demo_h_general = /** @type {((inputs?: Funnel_Ob_Demo_H_GeneralInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Demo_H_GeneralInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_demo_h_general(inputs)
	return en_funnel_ob_demo_h_general(inputs)
});